exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h3[data-v-3d41ac8c] {\n  font-size: 1.42275rem;\n}\n.el-select[data-v-3d41ac8c] {\n  display: block !important;\n}\n.alert[data-v-3d41ac8c] {\n  position: relative;\n  margin-bottom: 1rem;\n  border: 1px solid transparent;\n  border-radius: 0.35rem;\n}\n.alert-secondary[data-v-3d41ac8c] {\n  color: #3c4657;\n  background-color: #e2e3e5;\n  border-color: #d6d8db;\n}", ""]);

// exports
